export default __webpack_public_path__ + "static/media/i164jp.cee4d9e4.webp";